export default {
    byCountry(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('country', id).get()
            )
        )
    }
}
